import { useRef, useState, useCallback } from 'react';
import { resolvePlaceDetails } from '@/utils/googlePlace';
import GoogleAutocompleteInput from './GoogleAutoCompleteInput';
import MapDisplay from './MapDisplay';
import { useGoogleMaps } from './GoogleMapsProvider';

const AutocompleteWithMap = ({ dict, onChange }) => {
    const { isLoaded, loadError } = useGoogleMaps();
    const [location, setLocation] = useState(null);
    const autocompleteRef = useRef(null);

    // El parseo de `address_components` y los dos fallbacks de código postal
    // viven en `utils/googlePlace.js`, compartidos con el cotizador.
    const handlePlaceSelect = useCallback(async (place) => {
        const addressDetails = await resolvePlaceDetails(place);

        if (!addressDetails) return;

        onChange?.(addressDetails);
        setLocation({ lat: addressDetails.lat, lng: addressDetails.lng });
    }, [onChange]);

    if (loadError) return <div>Error al cargar el mapa</div>;
    if (!isLoaded) return <div>Cargando mapa…</div>;

    return (
        <>
            <GoogleAutocompleteInput
                onPlaceSelect={handlePlaceSelect}
                autocompleteRef={autocompleteRef}
                dict={dict}
            />
            <MapDisplay
                location={location}
                idMap='4504f8b37365c3d0'
                dict={dict}
            />
        </>
    );
};

export default AutocompleteWithMap;
